(function () {
  var FILTER_KEYS = ['brand', 'price', 'savings', 'function', 'concern'];
  var mobileQuery = window.matchMedia('(max-width: 989px)');

  function isMobile() {
    return mobileQuery.matches;
  }

  function checkedIn(root, group) {
    return Array.prototype.slice.call(
      root.querySelectorAll('[data-promo-group="' + group + '"]:checked')
    );
  }

  function searchInput(root) {
    return root.querySelector('[data-promo-search]');
  }

  function sheetEl(root) {
    return root.querySelector('[data-promo-sheet]');
  }

  function sheetOpen(root) {
    var sheet = sheetEl(root);
    return !!(sheet && sheet.classList.contains('is-open'));
  }

  function closePanels(root) {
    root.querySelectorAll('[data-promo-trigger]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('.promo-filters__panel').forEach(function (panel) {
      panel.hidden = true;
    });
  }

  function placePanel(button, panel) {
    var rect = button.getBoundingClientRect();
    panel.hidden = false;
    panel.style.top = Math.round(rect.bottom + 6) + 'px';
    panel.style.left = Math.round(Math.max(8, rect.left)) + 'px';
    var box = panel.getBoundingClientRect();
    if (box.right > window.innerWidth - 8) {
      panel.style.left = Math.max(8, window.innerWidth - box.width - 8) + 'px';
    }
  }

  function cardTags(card) {
    return (card.getAttribute('data-tags') || '').split('||').filter(Boolean);
  }

  function matchesGroup(card, boxes, group) {
    if (!boxes.length) return true;
    if (group === 'brand') {
      var vendor = card.getAttribute('data-vendor') || '';
      return boxes.some(function (box) { return box.value === vendor; });
    }
    if (group === 'price') {
      var price = Number(card.getAttribute('data-price') || 0);
      return boxes.some(function (box) {
        var min = Number(box.getAttribute('data-min'));
        var max = Number(box.getAttribute('data-max'));
        return price >= min && price <= max;
      });
    }
    if (group === 'savings') {
      var savings = Number(card.getAttribute('data-savings') || 0);
      return boxes.some(function (box) {
        var from = Number(box.getAttribute('data-from'));
        var to = Number(box.getAttribute('data-to'));
        if (from === 0) return savings > 0 && savings <= to;
        return savings >= from && savings <= to;
      });
    }
    var tags = cardTags(card);
    return boxes.some(function (box) { return tags.indexOf(box.value) !== -1; });
  }

  function cardMatches(card, root) {
    var search = searchInput(root);
    var query = search ? search.value.trim().toLowerCase() : '';
    var show = true;
    FILTER_KEYS.forEach(function (group) {
      if (!matchesGroup(card, checkedIn(root, group), group)) show = false;
    });
    if (show && query) {
      var hay = ((card.getAttribute('data-title') || '') + ' ' + (card.getAttribute('data-vendor') || '')).toLowerCase();
      if (hay.indexOf(query) === -1) show = false;
    }
    return show;
  }

  function countMatches(root) {
    var total = 0;
    root.querySelectorAll('[data-promo-card]').forEach(function (card) {
      if (cardMatches(card, root)) total += 1;
    });
    return total;
  }

  function labelTriggers(root) {
    root.querySelectorAll('[data-promo-trigger]').forEach(function (button) {
      var item = button.closest('.promo-filters__item');
      var base = button.getAttribute('data-label') || '';
      var count = item ? item.querySelectorAll('input:checked').length : 0;
      var label = button.querySelector('[data-trigger-label]');
      if (label) label.textContent = (!isMobile() && count) ? base + ' (' + count + ')' : base;
      button.classList.toggle('has-selection', count > 0);
      var badge = button.querySelector('[data-promo-count]');
      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      }
    });
  }

  function currentParams(root) {
    var params = new URLSearchParams();
    FILTER_KEYS.forEach(function (group) {
      checkedIn(root, group).forEach(function (box) {
        params.append(group, box.value);
      });
    });
    var search = searchInput(root);
    var query = search ? search.value.trim() : '';
    if (query) params.set('q', query);
    return params;
  }

  function syncLinks(root, params) {
    root.querySelectorAll('[data-promo-pagination] a, [data-promo-sort-menu] a').forEach(function (link) {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      var page = url.searchParams.get('page');
      var sort = link.getAttribute('data-sort-value');
      var next = new URLSearchParams(params.toString());
      if (page) next.set('page', page);
      if (sort) next.set('sort_by', sort);
      var qs = next.toString();
      link.setAttribute('href', url.pathname + (qs ? '?' + qs : ''));
    });
  }

  function writeUrl(params) {
    var existing = new URLSearchParams(window.location.search);
    var page = existing.get('page');
    var sort = existing.get('sort_by');
    if (page && page !== '1') params.set('page', page);
    if (sort) params.set('sort_by', sort);
    var qs = params.toString();
    var next = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    if (next !== window.location.pathname + window.location.search + window.location.hash) {
      window.history.replaceState(null, '', next);
    }
  }

  function appliedCount(root) {
    var total = 0;
    FILTER_KEYS.forEach(function (group) {
      total += checkedIn(root, group).length;
    });
    var search = searchInput(root);
    if (search && search.value.trim()) total += 1;
    return total;
  }

  function renderChips(root) {
    var box = root.querySelector('[data-promo-chips]');
    if (!box) return;
    var removeLabel = box.getAttribute('data-remove-label') || 'Remove';
    box.innerHTML = '';
    root.querySelectorAll('[data-promo-group]:checked').forEach(function (input) {
      var text = input.parentElement ? input.parentElement.querySelector('span') : null;
      var name = text ? text.textContent.trim() : input.value;
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'promo-sheet__chip';
      chip.setAttribute('aria-label', removeLabel + ': ' + name);
      var label = document.createElement('span');
      label.textContent = name;
      var mark = document.createElement('span');
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = '×';
      chip.appendChild(label);
      chip.appendChild(mark);
      chip.addEventListener('click', function () {
        input.checked = false;
        updateDraft(root);
      });
      box.appendChild(chip);
    });
    var search = searchInput(root);
    if (search && search.value.trim()) {
      var query = search.value.trim();
      var searchChip = document.createElement('button');
      searchChip.type = 'button';
      searchChip.className = 'promo-sheet__chip';
      searchChip.setAttribute('aria-label', removeLabel + ': ' + query);
      var searchLabel = document.createElement('span');
      searchLabel.textContent = query;
      var searchMark = document.createElement('span');
      searchMark.setAttribute('aria-hidden', 'true');
      searchMark.textContent = '×';
      searchChip.appendChild(searchLabel);
      searchChip.appendChild(searchMark);
      searchChip.addEventListener('click', function () {
        search.value = '';
        updateDraft(root);
      });
      box.appendChild(searchChip);
    }
    box.hidden = box.childElementCount === 0;
  }

  function updateViewLabel(root) {
    var view = root.querySelector('[data-promo-view]');
    if (!view) return;
    var template = view.getAttribute('data-view-label') || 'View __COUNT__ items';
    view.textContent = template.replace('__COUNT__', String(countMatches(root)));
  }

  function updateDraft(root) {
    labelTriggers(root);
    renderChips(root);
    updateViewLabel(root);
    var clear = root.querySelector('[data-promo-sheet-clear]');
    if (clear) clear.hidden = appliedCount(root) === 0;
  }

  function takeSnapshot(root) {
    var search = searchInput(root);
    root._promoSnap = {
      query: search ? search.value : '',
      checks: Array.prototype.map.call(root.querySelectorAll('[data-promo-group]'), function (box) {
        return box.checked;
      })
    };
  }

  function restoreSnapshot(root) {
    var snap = root._promoSnap;
    if (!snap) return;
    var search = searchInput(root);
    if (search) search.value = snap.query;
    root.querySelectorAll('[data-promo-group]').forEach(function (box, index) {
      box.checked = !!snap.checks[index];
    });
  }

  function setSheetOpen(root, open) {
    var sheet = sheetEl(root);
    if (!sheet) return;
    sheet.classList.toggle('is-open', open);
    if (open) {
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
    } else {
      sheet.removeAttribute('role');
      sheet.removeAttribute('aria-modal');
    }
    document.body.classList.toggle('promo-sheet-open', open);
    var opener = root.querySelector('[data-promo-open]');
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var close = root.querySelector('[data-promo-sheet-close]');
      if (close) close.focus();
    }
  }

  function apply(root, updateUrl) {
    var cards = root.querySelectorAll('[data-promo-card]');
    var visible = 0;
    cards.forEach(function (card) {
      var show = cardMatches(card, root);
      card.classList.toggle('is-hidden', !show);
      if (show) visible += 1;
    });

    var status = root.querySelector('[data-promo-status]');
    if (status) {
      var template = status.getAttribute('data-showing') || 'Showing __COUNT__';
      status.textContent = template.replace('__COUNT__', String(visible));
    }

    var empty = root.querySelector('[data-promo-empty]');
    if (empty) empty.hidden = !(cards.length && visible === 0);

    var clear = root.querySelector('[data-promo-clear]');
    var params = currentParams(root);
    if (clear) clear.hidden = params.toString() === '';

    var openCount = root.querySelector('[data-promo-open-count]');
    if (openCount) {
      var total = appliedCount(root);
      openCount.textContent = String(total);
      openCount.hidden = total === 0;
    }

    labelTriggers(root);
    updateViewLabel(root);
    syncLinks(root, params);
    if (updateUrl) writeUrl(params);
  }

  function clearFilters(root) {
    root.querySelectorAll('[data-promo-group]').forEach(function (box) { box.checked = false; });
    var search = searchInput(root);
    if (search) search.value = '';
  }

  function restore(root) {
    var params = new URLSearchParams(window.location.search);
    FILTER_KEYS.forEach(function (group) {
      var wanted = params.getAll(group);
      if (!wanted.length) return;
      root.querySelectorAll('[data-promo-group="' + group + '"]').forEach(function (box) {
        if (wanted.indexOf(box.value) !== -1) box.checked = true;
      });
    });
    var search = searchInput(root);
    if (search && params.get('q')) search.value = params.get('q');
  }

  function init(root) {
    if (!root || root.getAttribute('data-promo-ready') === 'true') return;
    root.setAttribute('data-promo-ready', 'true');
    restore(root);

    root.querySelectorAll('[data-promo-trigger]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.promo-filters__item');
        var panel = item && item.querySelector('.promo-filters__panel');
        if (!panel) return;
        var willOpen = panel.hidden;
        closePanels(root);
        if (!willOpen) return;
        button.setAttribute('aria-expanded', 'true');
        if (isMobile()) {
          panel.style.top = '';
          panel.style.left = '';
          panel.hidden = false;
        } else {
          placePanel(button, panel);
        }
      });
    });

    root.addEventListener('change', function (event) {
      if (!(event.target && event.target.matches('[data-promo-group]'))) return;
      if (sheetOpen(root)) updateDraft(root);
      else apply(root, true);
    });

    var search = searchInput(root);
    if (search) {
      search.addEventListener('input', function () {
        if (sheetOpen(root)) updateDraft(root);
        else apply(root, true);
      });
    }

    var clear = root.querySelector('[data-promo-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        clearFilters(root);
        apply(root, true);
        closePanels(root);
      });
    }

    var opener = root.querySelector('[data-promo-open]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.addEventListener('click', function () {
        takeSnapshot(root);
        closePanels(root);
        updateDraft(root);
        setSheetOpen(root, true);
      });
    }

    var closer = root.querySelector('[data-promo-sheet-close]');
    if (closer) {
      closer.addEventListener('click', function () {
        restoreSnapshot(root);
        closePanels(root);
        setSheetOpen(root, false);
      });
    }

    var sheetClear = root.querySelector('[data-promo-sheet-clear]');
    if (sheetClear) {
      sheetClear.addEventListener('click', function () {
        clearFilters(root);
        closePanels(root);
        updateDraft(root);
      });
    }

    var view = root.querySelector('[data-promo-view]');
    if (view) {
      view.addEventListener('click', function () {
        apply(root, true);
        takeSnapshot(root);
        closePanels(root);
        setSheetOpen(root, false);
      });
    }

    var sortButton = root.querySelector('[data-promo-sort]');
    var sortMenu = root.querySelector('[data-promo-sort-menu]');
    if (sortButton && sortMenu) {
      sortButton.addEventListener('click', function () {
        var willOpen = sortMenu.hidden;
        sortMenu.hidden = !willOpen;
        sortButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function () {
        if (!isMobile() && sheetOpen(root)) {
          apply(root, true);
          closePanels(root);
          setSheetOpen(root, false);
        }
        labelTriggers(root);
      });
    }

    apply(root, false);
    updateDraft(root);
  }

  function boot() {
    document.querySelectorAll('[data-promo-catalog]').forEach(init);
  }

  boot();

  if (!window.__bbPromoDoc) {
    window.__bbPromoDoc = true;
    document.addEventListener('click', function (event) {
      document.querySelectorAll('[data-promo-catalog]').forEach(function (root) {
        var sort = root.querySelector('.promo-sort');
        if (sort && !sort.contains(event.target)) {
          var sortMenu = root.querySelector('[data-promo-sort-menu]');
          var sortButton = root.querySelector('[data-promo-sort]');
          if (sortMenu) sortMenu.hidden = true;
          if (sortButton) sortButton.setAttribute('aria-expanded', 'false');
        }
        var filters = root.querySelector('[data-promo-filters]');
        if (filters && !filters.contains(event.target) && !sheetOpen(root)) closePanels(root);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-promo-catalog]').forEach(function (root) {
        if (sheetOpen(root)) {
          restoreSnapshot(root);
          closePanels(root);
          setSheetOpen(root, false);
          return;
        }
        closePanels(root);
        var sortMenu = root.querySelector('[data-promo-sort-menu]');
        var sortButton = root.querySelector('[data-promo-sort]');
        if (sortMenu) sortMenu.hidden = true;
        if (sortButton) sortButton.setAttribute('aria-expanded', 'false');
      });
    });
    window.addEventListener('scroll', function (event) {
      var target = event.target;
      if (target && target.closest && (target.closest('.promo-filters__panel') || target.closest('.promo-sheet') || target.closest('.promo-sort'))) return;
      document.querySelectorAll('[data-promo-catalog]').forEach(function (root) {
        if (!sheetOpen(root)) closePanels(root);
      });
    }, true);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-promo-catalog]')
        : null;
      if (root) init(root);
    });
  }
})();
